import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  className?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = "加载中...",
  className
}) => {
  if (!isVisible) return null;

  return (
    <div 
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm",
        "animate-in fade-in-0 duration-300",
        className
      )}
    >
      <div className="flex flex-col items-center space-y-4 p-6 bg-card rounded-lg shadow-lg border">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        <p className="text-sm text-muted-foreground animate-pulse">{message}</p>
      </div>
    </div>
  );
};

interface LogoutLoadingProps {
  isVisible: boolean;
}

export const LogoutLoading: React.FC<LogoutLoadingProps> = ({ isVisible }) => {
  return (
    <LoadingOverlay
      isVisible={isVisible}
      message="正在安全退出您的账户..."
      className="bg-background/90"
    />
  );
};